import { DomainDataType } from "../types/DomainDataType";
import { BaseApi } from "./BaseApi";
import { Vendedor } from "../../types/Vendedor";
import { ComissaoPorClassificacaoDadosParaFiltro, ComissaoPorClassificacaoResultado } from "app/types/Comissao-por-classificacao/ComissaoPorClassificacao";


export class ComissaoPorClassificacaoApi extends BaseApi {
    async ObterDadosParaFiltro() : Promise<ComissaoPorClassificacaoDadosParaFiltro> { // 482087
        var retorno = await this.api.get(`/ComissaoPorClassificacao/ObterDadosParaFiltro`)
        
        return retorno.data
    }
    async Obter(codigoVendedorLogado: string, codigoFilialFiltro: string, codigoVendedorFiltro: string, dataInicialFiltro: Date, dataFinalFiltro: Date)
                : Promise<ComissaoPorClassificacaoResultado[]> 
    { // 482087
        
        var retorno = await this.api.post(`/ComissaoPorClassificacao/Obter`, { // 482087
            codigoVendedorLogado,
            codigoFilialFiltro,
            codigoVendedorFiltro,
            dataInicialFiltro,
            dataFinalFiltro
        })
        
        return retorno.data
    }
}

